import { createSelector } from 'reselect';
import get from 'lodash/get';

export const selectActiveEncounterNoteSectionId = createSelector(
  state => state.encounterNote.activeEncounterNoteSectionId,
  subState => subState,
);

export const selectEncounterTemplateSectionIds = createSelector(
  state => state.encounterNote.encounterData,
  subState => get(subState, 'template.sections', []),
);

export const selectEncounterNoteSections = createSelector(
  state => state.encounterNote.encounterNoteSections,
  subState => subState,
);

export const selectQuestions = createSelector(
  state => state.encounterNote.questions,
  subState => subState,
);
export const selectOptions = createSelector(
  state => state.encounterNote.options,
  subState => subState,
);

export const selectEncounterNoteObject = createSelector(
  state => state.encounterNote.encounterNote,
  subState => subState,
);

export const selectEncounterDataObject = createSelector(
  state => state.encounterNote.activeEncounter,
  subState => subState,
);

export const selectEncounterTemplateSections = createSelector(
  state => state.encounterNote.encounterTemplateSections,
  subState => subState,
);
export const physicianNotesSelector = createSelector(
  state => state.encounterNote.physicianNotes,
  subState => subState,
);

export const pastPhysicianNotesSelector = createSelector(
  state => state.encounterNote.pastPhysicianNotes,
  subState => subState,
);
